import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import hamburger from "../assets/hamburger.svg";
import { useCallback, useState } from "react";
import ProfileImage from "../assets/default-profile-icon.svg";
import { useSession } from "../stores/session_store";
import { Md5 } from "ts-md5";
import { useCats } from "../stores/cat_store";
import franceFlag from "../assets/france-flag-icon.svg";
import englandFlag from "../assets/united-kingdom-flag-icon.svg";
import {
  addLanguageToGlobalStore,
  useLanguage,
} from "../stores/language_store";
import { Translate } from "./translate";

export function Header() {
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [isProfileVisible, setIsProfileVisible] = useState(false);
  const location = useLocation();
  const session = useSession();
  const cats = useCats();
  const language = useLanguage();

  const menuHandleClick = useCallback(
    () => setIsMenuVisible(!isMenuVisible),
    [isMenuVisible]
  );

  const profileHandleClick = useCallback(
    () => setIsProfileVisible(!isProfileVisible),
    [isProfileVisible]
  );

  const frFlagHandleClick = () => {
    addLanguageToGlobalStore("french");
  };

  const enFlagHandleClick = () => {
    addLanguageToGlobalStore("english");
  };

  return (
    <Container $isBig={isMenuVisible || isProfileVisible}>
      <TopBar>
        <MenuIcon
          onClick={menuHandleClick}
          src={hamburger}
          alt="hamburger menu"
        />
        <TitleBar>React Apps</TitleBar>
        <ContainerRight>
          <ContainerFlag>
            <Flag
              onClick={frFlagHandleClick}
              src={franceFlag}
              alt="france flag"
              $isActive={language === "french"}
            />
            <Flag
              onClick={enFlagHandleClick}
              src={englandFlag}
              alt="england flag"
              $isActive={language === "english"}
            />
          </ContainerFlag>
          {session === undefined ? (
            <ProfilePhoto
              onClick={profileHandleClick}
              src={ProfileImage}
              alt="Profile Image"
            />
          ) : (
            <ProfilePhoto
              onClick={profileHandleClick}
              src={`https://gravatar.com/avatar/${Md5.hashStr(session.email)}`}
              alt="Profile Image"
            />
          )}
        </ContainerRight>
      </TopBar>
      {isMenuVisible ? (
        <NavBar>
          <StyledLink
            to="/"
            onClick={menuHandleClick}
            $isSelected={location.pathname === "/"}
          >
            <Translate value="home" />
          </StyledLink>
          <StyledLink
            to="/joke"
            onClick={menuHandleClick}
            $isSelected={location.pathname === "/joke"}
          >
            <Translate value="jokes" />
          </StyledLink>
          <StyledLink
            to="/cat"
            onClick={menuHandleClick}
            $isSelected={location.pathname === "/cat"}
          >
            <Translate value="cat_generator" />
          </StyledLink>
          <StyledLink
            to="/rock-paper-scissors"
            onClick={menuHandleClick}
            $isSelected={location.pathname === "/rock-paper-scissors"}
          >
            <Translate value="rps" />
          </StyledLink>
          <StyledLink
            to="/form"
            onClick={menuHandleClick}
            $isSelected={location.pathname === "/form"}
          >
            <Translate value="contact_form" />
          </StyledLink>
          <StyledLink
            to="/history-cat"
            onClick={menuHandleClick}
            $isSelected={location.pathname === "/history-cat"}
          >
            <Translate value="history_cat" /> ({cats.length})
          </StyledLink>
          <StyledLink
            to="/characters-lol"
            onClick={menuHandleClick}
            $isSelected={location.pathname === "/characters-lol"}
          >
            <Translate value="lol_char" />
          </StyledLink>
          <StyledLink
            to="/to_do_list"
            onClick={menuHandleClick}
            $isSelected={location.pathname === "/to_do_list"}
          >
            <Translate value="to_do_list" />
          </StyledLink>
        </NavBar>
      ) : (
        <></>
      )}
      {isProfileVisible ? <ProfileBar>test</ProfileBar> : <></>}
    </Container>
  );
}

const TopBar = styled.div`
  height: 40px;
  width: 100%;
  background-color: rgb(56, 113, 219);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const NavBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  background-color: rgb(236, 236, 236);
  flex-grow: 1;
  width: 80%;
  max-width: 330px;
`;

const ProfileBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  background-color: rgb(236, 236, 236);
  margin-left: calc(100% - 200px);
`;

const StyledLink = styled(Link)<{ $isSelected: boolean }>`
  text-decoration: none;
  font-size: 20px;
  color: ${({ $isSelected }) => ($isSelected ? "rgb(56, 113, 219)" : "black")};
`;

const Container = styled.div<{ $isBig: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  height: ${({ $isBig }) => ($isBig ? "100%" : "auto")};
  display: flex;
  flex-direction: column;
  z-index: 1;
`;

const MenuIcon = styled.img`
  width: 20px;
  margin: 12px;
`;

const TitleBar = styled.h1`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 5px;
  font-size: 25px;
  color: rgb(14, 220, 235);
`;

const ProfilePhoto = styled.img`
  height: 30px;
  width: 30px;
  margin: 5px;
  object-fit: cover;
  border-radius: 50%;
`;

const Flag = styled.img<{ $isActive: boolean }>`
  width: 20px;
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.2)};
  cursor: pointer;
`;

const ContainerRight = styled.div`
  display: flex;
`;

const ContainerFlag = styled.div`
  display: flex;
  gap: 5px;
`;
